import {AxiosRequestConfig, AxiosResponse, Method} from 'axios'
import axios from '../axios'
import {CHECK_TOKEN} from '../../modules/auth/core/_requests'
import * as authHelper from '../../modules/auth/core/AuthHelpers'

export abstract class Http {
  public static async get<T>(url: string, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    return await this.perform({
      method: 'get',
      url,
      ...config,
    })
  }

  public static async put<T>(
    url: string,
    data: any,
    config?: AxiosRequestConfig
  ): Promise<AxiosResponse<T>> {
    return await this.perform({
      method: 'put',
      url,
      data,
      ...config,
    })
  }

  public static async post<T>(
    url: string,
    data: any,
    config?: AxiosRequestConfig
  ): Promise<AxiosResponse<T>> {
    return await this.perform({
      method: 'post',
      url,
      data,
      ...config,
    })
  }

  public static async delete<T>(
    url: string,
    config?: AxiosRequestConfig
  ): Promise<AxiosResponse<T>> {
    return await this.perform({
      method: 'delete',
      url,
      ...config,
    })
  }

  private static async perform<T>(config: AxiosRequestConfig, retriedAfterRefresh = false): Promise<T> {
    const result = await axios.request<T & any>(config)

    if (result.data.status === 'TOKEN_EXPIRED') {
      // Guard against an infinite loop if the server keeps reporting the token as
      // expired even right after a successful refresh.
      if (retriedAfterRefresh) {
        authHelper.removeAuth()
        return result.data
      }

      const {data} = await axios.get(CHECK_TOKEN)

      if (data.status === 'OK') {
        const {data: token} = data

        authHelper.setAuth({
          jwt_key: token.jwt_key,
          token: token.new_token,
        })

        return this.perform<T>(config, true)
      }

      authHelper.removeAuth()
    }

    if (result.data.status === 'TOKEN_NOT_FOUND') {
      authHelper.removeAuth()
      window.location.reload()
    }

    return result.data
  }
}
